import {
  addSurveyAnswers,
  SurveyAnswersState,
} from "@utils/redux/slices/surveyAnswers";
import { updateCurrentAnswers } from "src/utils/redux/slices/currentAnswers";
import { getPageSetSurvey } from "./util";
import { ActionHandlerParams } from "..";
import { getSurveyAnswers } from "src/hooks/survey/answers";
import { prepareAndTrackSurveyAnswers } from "src/utils/mainSurvey";
import { calculateBMIMetric } from "src/primitive/bmi";
import Unit, { getWeightDisplayUnit, convertUnits } from "src/utils/Unit";
import { isHealthRoute } from "src/utils/userSegment";
import { hasWeightLossGoal } from "src/utils/userSegment/features";

const questionId = "idealWeight";

export const setIdealWeightToCurrentWeight = ({
  store,
  pageSet,
  page,
}: ActionHandlerParams): void => {
  const survey = getPageSetSurvey(pageSet, page);
  const surveyAnswers = getSurveyAnswers();
  const { heightCm, weightKg, weight, weightUnit, currentBMI } = surveyAnswers;

  if (!heightCm || !weightKg) {
    return;
  }

  const bmi = currentBMI || calculateBMIMetric(heightCm, weightKg);

  if (!isHealthRoute() || !hasWeightLossGoal() || bmi >= 18.5) {
    return;
  }

  const answers: Partial<SurveyAnswersState> = {
    idealWeightKg: weightKg,
    idealWeightUnit: weightUnit || getWeightDisplayUnit(surveyAnswers).id,
    targetBMI: currentBMI,
    idealWeight:
      weight ||
      convertUnits({ mainUnitValue: weightKg }, Unit.KILOGRAM, Unit.POUND)
        .mainUnitValue,
  };

  store.dispatch(addSurveyAnswers(answers));

  store.dispatch(
    updateCurrentAnswers({
      namespace: survey.surveyNameSpace,
      answers,
    })
  );

  // Track the answer to Mixpanel
  const updatedSurveyAnswers = getSurveyAnswers();
  prepareAndTrackSurveyAnswers(questionId, updatedSurveyAnswers);
};
